/**
 * Default CV template for the studio: last used, then a stable classic look.
 */

export const LAST_TEMPLATE_KEY = 'clarcv.lastTemplateId';

export const PREFERRED_TEMPLATE_NAMES = [
  'Elegant Classic',
  'Luxury Executive',
  'Art Deco Luxe',
];

/**
 * Read the last template id from localStorage.
 *
 * @returns {string|null}
 */
export const readStoredTemplateId = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return window.localStorage.getItem(LAST_TEMPLATE_KEY);
  } catch (err) {
    return null;
  }
};

/**
 * Persist the last chosen template id.
 *
 * @param {string|number} id
 */
export const storeTemplateId = (id) => {
  if (typeof window === 'undefined' || id == null) {
    return;
  }
  try {
    window.localStorage.setItem(LAST_TEMPLATE_KEY, String(id));
  } catch (err) {
    // Private mode / quota — studio still works without persistence.
  }
};

/**
 * Pick a template to apply when the studio opens.
 *
 * @param {Array<Object>} templates
 * @param {string|number} [preferred] - id or canonical name from navigation
 * @returns {Object|null}
 */
export const pickDefaultTemplate = (templates, preferred) => {
  if (!Array.isArray(templates) || templates.length === 0) {
    return null;
  }
  if (preferred != null && preferred !== '') {
    const byId = templates.find((item) => String(item.id) === String(preferred));
    if (byId) {
      return byId;
    }
    const byName = templates.find((item) => item.name === preferred);
    if (byName) {
      return byName;
    }
  }
  const stored = readStoredTemplateId();
  if (stored) {
    const byStored = templates.find((item) => String(item.id) === String(stored));
    if (byStored) {
      return byStored;
    }
  }
  for (let i = 0; i < PREFERRED_TEMPLATE_NAMES.length; i += 1) {
    const name = PREFERRED_TEMPLATE_NAMES[i];
    const match = templates.find((item) => item.name === name);
    if (match) {
      return match;
    }
  }
  return templates[0];
};
